import { IModal } from 'customTypes';
import { BtnBlue, BtnGhost, BtnRed, BtnWhite } from '../Button';
import { ModalBackground, Modal } from '../../assets/styles/Modal';
import { useTranslation } from 'react-i18next';
import { CCTV_VIEWER_PLUGIN_URL, WEBSDK_RESTART_PLUGIN_URL } from '../../_constants';

const WebSdkModal = ({ openModal, setOpenModal, state }: any) => {
  const { t } = useTranslation();

  // 닫기버튼 클릭
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };
  // 다운로드버튼 클릭
  const onClickDownload = async () => {
    window.location.href = openModal.data === 'pluginRestart' ? WEBSDK_RESTART_PLUGIN_URL : CCTV_VIEWER_PLUGIN_URL;
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };
  return (
    <ModalBackground>
      <Modal>
        <div className='modal delete'>
          <div className='inputForm-head'>{openModal.data === 'pluginRestart' ? t('PLUGIN HELPER를 설치해주세요') : t('PLUGIN을 설치해주세요')}</div>
          <div className='inputForm-body'>
            <div className='modal-footer flex-end'>
              <BtnGhost onClick={onClickDownload}>{openModal.data === 'pluginRestart' ? t('PLUGIN HELPER 다운로드') : t('PLUGIN 다운로드')}</BtnGhost>
              <BtnGhost onClick={onClickClose}>{t('닫기')}</BtnGhost>
            </div>
          </div>
        </div>
      </Modal>
    </ModalBackground>
  );
};

export default WebSdkModal;
